"use strict";

angular.module("vendor")
.service("CustomerFinancialService", function(
    $resource, FlashBag, gettextCatalog, common, PartnershipSelectorUnregisteredServiceFactory, appConfig,
    PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES
) {
    const LISTING_URL = "/auth/vendor/partnerships/list/";
    const URL_PARAMS = {has_invoice: 1};

    function CustomerFinancialService() {
        PartnershipSelectorUnregisteredServiceFactory.call(this, LISTING_URL, URL_PARAMS);

        this.getBulkActionParams = function() {
            var creditLimitBlockResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/credit-limit/block/");
            var creditLimitWarningResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/credit-limit/warning/");
            var overdueBlockResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/overdue/block/");
            var overdueWarningResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/overdue/warning/");
            var sendFinancialReminderResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/send-customer-reminder/");
            var updateAllowedPaymentMethodsResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/update-allowed-payment-methods/");
            var updateAllowedPreAuthorizedPaymentMethodsResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/update-allowed-pre-authorized-payment-methods/");
            var updatePreAuthorizedPaymentAgreementTypeResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/update-pre-authorized-payment-agreement-type/");

            return {
                credit_limit_block: {
                    text: gettextCatalog.getString("Block Over Credit Limit"),
                    message: gettextCatalog.getString("Do you really want to block these customers to be over credit limit?"),
                    resource: creditLimitBlockResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-credit-limit",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialCreditLimitConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl",
                    params: {
                        creditLimitValueRequired: true
                    }
                },
                credit_limit_warning: {
                    text: gettextCatalog.getString("Warning Over Credit Limit"),
                    message: gettextCatalog.getString("Do you really want to warn these customers to be over credit limit?"),
                    resource: creditLimitWarningResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-credit-limit",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialCreditLimitConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl",
                    params: {
                        creditLimitValueRequired: false
                    }
                },
                overdue_block: {
                    text: gettextCatalog.getString("Block Overdue"),
                    message: gettextCatalog.getString("Do you really want to block these customers to be overdue?"),
                    resource: overdueBlockResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-overdue",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialOverdueConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl",
                    params: {
                        netPaymentDaysValueRequired: true
                    }
                },
                overdue_warning: {
                    text: gettextCatalog.getString("Warning Overdue"),
                    message: gettextCatalog.getString("Do you really want to warn these customers to be overdue?"),
                    resource: overdueWarningResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-overdue",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialOverdueConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl",
                    params: {
                        netPaymentDaysValueRequired: false
                    }
                },
                update_allowed_payment_methods: {
                    text: gettextCatalog.getString("Update allowed payment methods"),
                    message: gettextCatalog.getString("Do you really want to update these customer's payment methods?"),
                    resource: updateAllowedPaymentMethodsResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-payment-methods",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialPaymentMethodsConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl"
                },
                update_allowed_pre_authorized_payment_methods: {
                    text: gettextCatalog.getString("Update allowed pre-authorized payment methods"),
                    message: gettextCatalog.getString("Do you really want to update these customer's pre-authorized payment methods?"),
                    resource: updateAllowedPreAuthorizedPaymentMethodsResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-pre-authorized-payment-methods",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialPreAuthorizedPaymentMethodsConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl"
                },
                update_pre_authorized_payment_agreement_type: {
                    text: gettextCatalog.getString("Update pre-authorized payment agreement type"),
                    message: gettextCatalog.getString("Do you really want to update these customer's pre-authorized payment agreement type?"),
                    resource: updatePreAuthorizedPaymentAgreementTypeResource,
                    successMessage: gettextCatalog.getString("Customers were updated successfully."),
                    modalTemplatePrefix: "partnership-financial-pre-authorized-payment-agreement-type",
                    modalTemplatePackage: "vendor",
                    controller: "PartnershipsFinancialPreAuthorizedPaymentAgreementTypeConfirmationController",
                    controllerAs: "partnershipsFinancialConfirmationCtrl"
                },
                send_financial_reminder: {
                    text: gettextCatalog.getString("Send Financial Statement and Payment Reminder"),
                    message: gettextCatalog.getString("Selected partnerships without unpaid invoices will be ignored. Do you really want to send a financial statement and payment reminder to these customers?"),
                    resource: sendFinancialReminderResource,
                    successMessage: gettextCatalog.getString("Financial statement and payment reminder was sent successfully."),
                    modalTemplatePrefix: "partnership-financial-send-reminder",
                    modalTemplatePackage: "vendor",
                }
            };
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };

        this.getSortFields = function() {
            return common.getSortFieldsByKeys(
                "company_name, buyer_number, status_date",
                this.getAvailableSortFields()
            );
        };


        this.getPreAuthorizedPaymentAgreementTypeTranslations = function() {
            var agreementTypes = {};
            agreementTypes[PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES.NONE] = gettextCatalog.getString(
                "None", null, "Pre-authorized payment agreement type"
            );
            agreementTypes[PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES.OPTIONAL] = gettextCatalog.getString(
                "Optional", null, "Pre-authorized payment agreement type"
            );
            agreementTypes[PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES.MANDATORY] = gettextCatalog.getString(
                "Mandatory", null, "Pre-authorized payment agreement type"
            );
            return agreementTypes;
        }

    }

    return new CustomerFinancialService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-financial.service.js
// module id = 871
// module chunks = 0